import ToolTip from "components/design/toolTip";

const getNexusTypeTooltipText = (nexusType: string[]) => {
  if (nexusType.length > 1) {
    return (
      <ul className="t-m-0 t-p-0 t-px-4">
        <li className="t-text-left">
          Economic nexus due to sales and no. of <br /> transactions being more
          than threshold
        </li>
        <li className="t-text-left t-mt-2">
          Physical nexus due to presence of <br /> office, warehouse and
          employee
        </li>
      </ul>
    );
  }

  if (nexusType.includes("Economic")) {
    return (
      <p className="t-text-left t-m-0">
        Economic nexus due to sales and no. of <br /> transactions being more
        than threshold
      </p>
    );
  }
  return (
    <p className="t-text-left t-m-0">
      Physical nexus due to presence of <br /> office, warehouse and employee
    </p>
  );
};

export const StateCell = ({
  jurisdiction,
  nexusType,
  isExempted,
}: {
  jurisdiction: string;
  nexusType: string[];
  isExempted: boolean;
}) => {
  const hasNexusType = nexusType.length > 0 && !isExempted;

  return (
    <div className="t-flex t-flex-col t-gap-0.5">
      <span>{jurisdiction}</span>
      {hasNexusType && (
        <ToolTip text={getNexusTypeTooltipText(nexusType)} side="bottom">
          <div className="t-flex t-gap-x-1 t-justify-start">
            {nexusType.map((type) => (
              <span
                className="t-text-body-sm t-text-text-30 t-text-nowrap"
                key={type}
              >
                {type} Nexus
              </span>
            ))}
          </div>
        </ToolTip>
      )}
    </div>
  );
};
